<template>
  <span @click="visible = true" style="display: inline-block">
    <slot name="importBtn">
      <a-button style="margin: 0 15px"> 文件导入 </a-button>
    </slot>
  </span>

  <a-modal
    v-model:visible="visible"
    class="organization-import--modal"
    title="导入数据"
    width="65%"
    :footer="false"
    :destroy-on-close="true"
    :after-close="closeModal"
  >
    <div class="scroll-container">
      <a-steps :current="currentStep">
        <a-step title="选择EXCEL表" />
        <a-step title="数据预览" />
        <a-step title="导入校验" />
        <a-step title="导入数据" />
      </a-steps>

      <select-file
        v-if="currentStep === 0"
        :loading-request="loading"
        :model-url="modelUrl"
        :templateKey="templateKey"
        @finishUpload="finishUpload"
      >
        <template #standard>
          <slot name="limit">
            <p>上传的Excel表符合以下规范:</p>

            <p>● 文件大小不超过10M，且单个sheet页数据量不超过1000行</p>
            <p>● 仅支持(.xls和*.xlsx)文件</p>
            <p>● 请确保您需要导入的sheet表头中不包含空的单元格，否则该sheet页数据系统将不做导入</p>
            <p>● 批量导入的数据不支持以“内置变量”作为条件的过滤</p>
            <p>● 导入文件不支持Excel公式计算，如SUM(A1:B3 A2:C2)等</p>
            <p>● 导入文件会覆盖已有信息，如需更新，请先导出数据，在导出表格里进行修改后再上传</p>
          </slot>
        </template>
      </select-file>

      <data-preview
        v-if="currentStep === 1"
        :data="tableData"
        :columns="columns"
        :tableHeight="tableHeight"
        @set-steps="setSteps"
      />
      <data-valid
        v-if="currentStep === 2"
        :data="checkData"
        :columns="columns"
        :checkLoading="checkLoading"
        :tableHeight="tableHeight"
        @set-steps="setSteps"
        @emitData="emitData"
        :keyFields="keyFields"
        :originalList="tableData.originalList"
        :checkKey="checkKey"
        :checkType="checkType"
      />
      <finish-import v-if="currentStep === 3" @handle-close="visible = false" />
    </div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { FormMultipleImportService } from "./form-multiple-import.service";
export default defineComponent({
  isGlobal: true,
  name: "FormMultipleImport",
});
</script>

<script lang="ts" setup>
import { ref, onMounted, computed, onUnmounted } from "vue";
import SelectFile from "./select-file.vue";
import DataPreview from "./data-preview.vue";
import DataValid from "./data-valid.vue";
import FinishImport from "./finish-import.vue";
import NP from "number-precision";
import { debounce } from "lodash";
import { message } from "ant-design-vue";
const props = defineProps({
  excelDataApiUrl: {
    type: String,
    required: true,
  },
  // uploadApiFn: {
  //   type: Function,
  //   required: true,
  // },
  // backPage: {
  //   type: String,
  //   required: true,
  // },
  modelUrl: {
    type: String,
  },
  templateKey: {
    type: String,
  },
  columns: {
    type: Array,
    default: () => [],
  },
  keyFields: {
    type: Array,
    default: () => [],
  },
  checkType: {
    type: String,
  },
});

const emit = defineEmits(["refresh", "loadData"]);

const visible = ref(false);
const checkKey = ref<string>("");

const currentStep = ref(0);
const checkLoading = ref(true);
let timer;
const { run, data, loading } = FormMultipleImportService.useGetExcelData();
const { run: runCheck, data: checkData } = FormMultipleImportService.useGetCheckData();

const tableData = computed(() => {
  return {
    failList: data?.value?.failList?.slice(0, 100) || [],
    originalList:
      data?.value?.originalList?.slice(0, 100) || data?.value?.initialList?.slice(0, 100) || [],
    passList: data?.value?.passList?.slice(0, 100) || [],
  };
});

async function finishUpload(url) {
  if (url && run) {
    const res = await run(props.excelDataApiUrl, url);
    if (res?.respCode === "0000") {
      currentStep.value = 1;
      checkKey.value = res?.data?.key || "";
    }
  }
}

function setSteps(step: number) {
  currentStep.value = step;
  if (step === 2) {
    loadCheckData();
  }
  if (step === 3) {
    emit("loadData", checkData.value?.passList);
  }
}
const emitData=(data) => {
  // console.log("🚀 ~ file: index.vue:151 ~ emitData ~ data:", data)
  currentStep.value = 3;
  emit("loadData", data);
}

const loadCheckData = async () => {
  let count = 0;
  checkLoading.value = true;
  async function intervalFn() {
    const res = await runCheck(checkKey.value);
    count++;
    if (res?.respCode === "0000" && checkData.value?.status == 3) {
      clearInterval(timer);
      checkLoading.value = false;
    } else if (checkData.value?.status == 3) {
      clearInterval(timer);
      checkLoading.value = false;
      message.warn("数据校验超时，请重新上传文件");
      setSteps(1);
    }
    if (count > 30||!checkKey.value) {
      clearInterval(timer);
      checkLoading.value = false;
    }
  }
  const r = await runCheck(checkKey.value);
  if (r?.respCode === "0000" && checkData.value?.status == 3) {
    checkLoading.value = false;
  } else if (checkData.value?.status == 3) {
    clearInterval(timer);
    checkLoading.value = false;
    message.warn("数据校验超时，请重新上传文件");
    setSteps(1);
  } else if (checkData.value?.status == -1) {
    clearInterval(timer);
    checkLoading.value = false;
    message.warn("上传文件有错误，请检查后重新上传");
    setSteps(1);
  }else {
    timer = setInterval(intervalFn, 3000);
  }
};

const tableHeight = ref(200);
function calcTableHeight() {
  const doumentHeight = window.innerHeight > 1000 ? 1000 : window.innerHeight;

  const calcHeight = NP.minus(NP.times(doumentHeight, 0.8), 235);
  tableHeight.value = calcHeight > 200 ? calcHeight : 200;
}
onMounted(() => {
  calcTableHeight();
});

const deCalcTableHeight = debounce(calcTableHeight, 200);

window.addEventListener("resize", deCalcTableHeight);

function closeModal() {
  currentStep.value = 0;
  // emit("loadData",data.originalList);
  data && (data.value = undefined);
  checkLoading.value = true;
  checkKey.value = "";
  timer && clearInterval(timer);
}

onUnmounted(() => {
  window.removeEventListener("resize", deCalcTableHeight);
});
</script>

<style lang="less">
.organization-import--modal {
  .ant-steps {
    margin-bottom: 20px;
    padding: 0 60px;
  }

  .ant-modal-content {
    max-height: 80vh;
  }
  .ant-modal-body {
    max-height: calc(80vh - 55px);
    padding: 20px 0;
    overflow: hidden;
    .scroll-container {
      max-height: calc(80vh - 95px);
      box-sizing: border-box;
      overflow-y: auto;
    }
  }
}
</style>
